import React from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import noImage from '../../../../assets/images/no-image.png';

function GroupCard({ imgPath, eleGrp, handleCheckGroup, index, selectedGroup, handleDelete, CareAddEditAccess, CareDeleteAccess }) {
  const history = useHistory();
  const { t } = useTranslation('common');

  const setImage = (item) => {
    let imagePath = '';

    if (item?.image && item.image.includes('data:image/png;base64')) {
      imagePath = item.image;
    } else if (item?.image) {
      imagePath = `${imgPath}/${item.image}`;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };
  return (
    <div className="listing-card card mb-5">
      <div className="image-detail">
        <figure>
          <div className="img-preview-inside-table">
            <span className="big-image">
              <img src={setImage(eleGrp)} alt="noImage" />
            </span>
            <img src={setImage(eleGrp)} alt="noImg" />
          </div>
        </figure>
      </div>
      <div className="card-header">
        <div>
          <ul className="card-header-icon">
            {CareDeleteAccess && (
              <li>
                <div className="cus-chk-block">
                  <input
                    name={`group_${index}`}
                    id={`group_${index}`}
                    onChange={(e) => handleCheckGroup(e.target.checked, eleGrp._id)}
                    checked={selectedGroup?.includes(eleGrp._id)}
                    type="checkbox"
                  />
                  <label htmlFor={`group_${index}`} className="cus-chklabel" />
                </div>
              </li>
            )}
            {CareAddEditAccess && (
              <li>
                <a
                  href={false}
                  title={t('CARE_LABELS.GROUP.GROUP_CARD.EDIT')}
                  onClick={() => {
                    if (eleGrp?._id) {
                      history.push(`/libraries/care-group/edit/${eleGrp?._id}`);
                    }
                  }}
                >
                  <i className="icon-edit" />
                </a>
              </li>
            )}
            {CareDeleteAccess && (
              <li>
                <a href={false} onClick={() => handleDelete(eleGrp?._id)} title={t('CARE_LABELS.GROUP.GROUP_CARD.DELETE')}>
                  <i className="icon-delete" />
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="card-body">
        <ul className="card-ul">
          <li>
            <strong>{t('CARE_LABELS.GROUP.GROUP_CARD.GROUP_NAME')} </strong>
            {eleGrp?.name}
          </li>
          <li>
            <strong>{t('CARE_LABELS.GROUP.GROUP_CARD.GROUP_DESCRIPTION')} </strong>
            {eleGrp?.description}
          </li>
          <li>
            <strong>
              {t('CARE_LABELS.GROUP.GROUP_CARD.CREATED_BY_DATE')} &amp; {t('CARE_LABELS.GROUP.GROUP_CARD.TIME')}{' '}
            </strong>
            {`${eleGrp.createdBy} | `}
            {moment(eleGrp.createdAt).format('DD-MMMM-YYYY, h:mm a')}
          </li>
          <li>
            <strong>
              {t('CARE_LABELS.GROUP.GROUP_CARD.MODIFIED_BY_DATE')} &amp; {t('CARE_LABELS.GROUP.GROUP_CARD.TIME')}{' '}
            </strong>
            {`${eleGrp.modifiedBy} | `}
            {moment(eleGrp.lastModifiedAt).format('DD-MMMM-YYYY, h:mm a')}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default GroupCard;
